<template>
  <div v-if="colors.length" class="color-selector">
    <span class="field-label">{{ $store.getters.t('color') }}</span>
    <div class="color-options">
      <button
        v-for="(color, index) in colors"
        :key="color.id || index"
        type="button"
        class="color-option"
        :class="{ active: index === selectedIndex }"
        :style="colorStyle(color)"
        :title="color.colorName || $store.getters.t('color')"
        :aria-label="color.colorName || $store.getters.t('color')"
        @click="selectColor(color, index)"
      >
        <img v-if="swatchImage(color)" :src="swatchImage(color)" alt="">
      </button>
    </div>
    <span class="color-name">{{ colors[selectedIndex] && colors[selectedIndex].colorName }}</span>
  </div>
</template>

<script>
export default {
  name: 'ColorSelector',
  props: { colors: { type: Array, default: () => [] } },
  data () { return { selectedIndex: 0 } },
  watch: {
    colors (value) {
      const firstImageIndex = value.findIndex(color => color && color.imageUrl)
      this.selectedIndex = firstImageIndex > -1 ? firstImageIndex : 0
    }
  },
  methods: {
    swatchImage (color) {
      return color && (color.swatchImageUrl || color.swatch_image_url) || ''
    },
    colorStyle (color) {
      return this.swatchImage(color) ? {} : { backgroundColor: color.colorValue || color.color_value || '#999' }
    },
    selectColor (color, index) {
      this.selectedIndex = index
      this.$emit('select', color)
    }
  }
}
</script>
